/* Adds keyboard/focus support without replacing the theme's cart requests. */
(function () {
  'use strict';
  var root = document.getElementById('layer-addcart-modal');
  if (!root || !root.classList.contains('rz-cart-confirmation')) return;
  var box = root.querySelector('.addcart-modal-box');
  var page = document.getElementById('page-body');
  var opened = false, returnFocus = null, originalInert = false;
  function visible() {
    return window.getComputedStyle(root).display !== 'none' && window.getComputedStyle(box).display !== 'none';
  }
  function sync() {
    var show = visible();
    if (show === opened) return;
    opened = show;
    if (show) {
      var title = box.querySelector('.addcart-modal-title');
      var fullTitle = title.textContent.trim();
      // Keep the actual Shopify title intact; only CSS shortens its visible line.
      title.title = fullTitle;
      var qtyLabel = box.querySelector('.addcart-modal-qty strong');
      if (qtyLabel) qtyLabel.textContent = 'In cart: ';
      returnFocus = document.activeElement;
      if (page && !page.contains(root)) { originalInert = page.inert; page.inert = true; }
      document.body.classList.add('rz-cart-dialog-open');
      box.querySelector('.addcart-modal-close').focus({ preventScroll: true });
    } else {
      if (page && !page.contains(root)) page.inert = originalInert;
      document.body.classList.remove('rz-cart-dialog-open');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
    }
  }
  function close() {
    if (window.AT_AddCart && typeof window.AT_AddCart.addcartModalHide === 'function') window.AT_AddCart.addcartModalHide();
  }
  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-rz-cart-close]')) close();
  });
  root.addEventListener('keydown', function (event) {
    if (!opened) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(box.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]'), function (element) { return element.getClientRects().length; });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  var observer = new MutationObserver(sync);
  observer.observe(root, { attributes: true, attributeFilter: ['style', 'class'] });
  observer.observe(box, { attributes: true, attributeFilter: ['style', 'class'] });
  sync();
})();

/* Keep quantity changes and all visible prices in one server-rendered update. */
(function () {
  'use strict';
  var root = document.querySelector('.page-cart[data-rz-cart-section]');
  if (!root || !root.querySelector('form') || root.dataset.rzCartAjax === 'true') return;
  var section = root.dataset.rzCartSection;
  var pending = false, needsReload = false;
  var status = document.createElement('p');
  status.className = 'rz-cart-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  root.querySelector('form').prepend(status);
  var localeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  function busy(on) {
    pending = on;
    root.setAttribute('aria-busy', String(on));
    root.classList.toggle('rz-cart-updating', on);
    root.querySelectorAll('.btn-checkout,.mobile-cart-action button').forEach(function (button) {
      if (on) { button.dataset.rzWasDisabled = String(button.disabled); button.disabled = true; }
      else if (!needsReload && button.dataset.rzWasDisabled === 'false') button.disabled = false;
    });
  }
  function apply(html, focusKey, focusClass) {
    if (!html) throw new Error('Your cart changed, but could not refresh. Please reload before checkout.');
    var next = new DOMParser().parseFromString(html, 'text/html');
    if (!next.querySelector('.cart-table')) throw new Error('Please reload to view your updated cart.');
    var checked = {};
    root.querySelectorAll('.agree-terms-condition').forEach(function (input) { checked[input.id] = input.checked; });
    ['.cart-table', '.rz-cart-total-after-items', '.cart-right-table'].forEach(function (selector) {
      var current = root.querySelector(selector), replacement = next.querySelector(selector);
      if (current && replacement) current.replaceWith(replacement);
    });
    root.querySelectorAll('.agree-terms-condition').forEach(function (input) { input.checked = !!checked[input.id]; });
    labelControls();
    if (root.querySelector('.agree-terms-condition') && window.AT_Main) window.AT_Main.termsConditions();
    var row = Array.prototype.find.call(root.querySelectorAll('.cart-item'), function (item) { return item.dataset.lineKey === focusKey; });
    if (row && focusClass) {
      var control = row.querySelector(focusClass);
      if (control) control.focus({preventScroll: true});
    }
  }
  function labelControls() {
    root.querySelectorAll('.qty-up,.qty-down').forEach(function (button) {
      button.tabIndex = 0;
      button.setAttribute('role', 'button');
      button.setAttribute('aria-label', button.classList.contains('qty-up') ? 'Increase quantity' : 'Decrease quantity');
    });
  }
  labelControls();
  root.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.qty-up,.qty-down')) {
      event.preventDefault(); event.target.click();
    }
  });
  async function renderCart(cart, key, focusClass) {
    var html = cart.sections && cart.sections[section];
    if (!html) {
      var response = await fetch(localeRoot + 'cart?sections=' + encodeURIComponent(section), {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) throw new Error('Please reload to view your updated cart.');
      html = (await response.json())[section];
    }
    apply(html, key, focusClass);
    if (window.Shopify && typeof window.Shopify.updateCartInfo === 'function') {
      window.Shopify.updateCartInfo(cart, '#cart-info #cart-content');
    }
  }
  root.addEventListener('click', async function (event) {
    // Section refreshes replace the mobile button, removing legacy direct bindings.
    // Delegate from the stable root and use the existing checkout submit button.
    if (event.target.closest('.mobile-cart-action button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pending || needsReload) return;
      var checkout = root.querySelector('.btn-checkout');
      if (checkout && !checkout.disabled) checkout.click();
      return;
    }
    var control = event.target.closest('.qty-up,.qty-down');
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending || needsReload) return;
    var row = control.closest('.cart-item');
    var quantity = Number(row.querySelector('.input-cart-qty').value) + (control.classList.contains('qty-up') ? 1 : -1);
    if (quantity < 1) return;
    var key = row.dataset.lineKey;
    var focusClass = control.classList.contains('qty-up') ? '.qty-up' : '.qty-down';
    status.textContent = 'Updating cart…';
    status.classList.remove('rz-cart-status-success');
    busy(true);
    try {
      var response = await fetch(localeRoot + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: key, quantity: quantity, sections: [section], sections_url: location.pathname})
      });
      var cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Could not update your cart. Please try again.');
      await renderCart(cart, key, focusClass);
      status.textContent = 'Cart updated.';
      status.classList.add('rz-cart-status-success');
    } catch (error) {
      status.textContent = error.message || 'Could not update your cart. Please reload before checkout.';
      needsReload = true;
      var reload = document.createElement('a');
      reload.href = location.href;
      reload.textContent = ' Reload cart';
      status.append(reload);
    } finally {
      busy(false);
    }
  }, true);
  /* Preserve the header-cart removal integration used by the original theme. */
  window.cartObj = {syncCartSB: function () { location.reload(); }};
})();
